import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import Modal from 'components/molecules/modal/modal'
import { Image as ImageType } from 'types/image'
import { LazyImage } from 'components/atoms/Image'
import { navigate } from 'gatsby'

const ImageWrapper = styled.div<{ $link?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 90vh;
  max-width: 100vw;

  ${({ $link }) =>
    $link &&
    css`
      .modal-image {
        cursor: pointer;
      }
    `}
`

export type PopupProps = {
  image: ImageType
  link?: string | null
}

const Popup: React.FC<PopupProps> = ({ image, link }) => {
  const [showModal, setShowModal] = useState(true)

  const closeModal = () => setShowModal(false)

  // I tried styling it so ImageWrapper would have a width and a height of an image within. However, doing so and keeping it responsive was a nightmare, so I just added an event listener to the image itself and made it navigate to the link if there is one.
  // Don't blame me for it
  useEffect(() => {
    if (!document) return

    const modalImage = document.querySelector('.modal-image')

    if (!modalImage) return

    modalImage.addEventListener('click', (e) => {
      e.stopPropagation()

      if (link) {
        navigate(link)
      }
    })
  }, [])

  return (
    <Modal visible={showModal} closeModal={closeModal}>
      <ImageWrapper
        $link={Boolean(link)}
        onClick={closeModal}
        style={{
          aspectRatio: `${image.src.width} / ${image.src.height}`,
          maxHeight: `minmax(${image.src.height}px, 90vh)`,
        }}
      >
        <LazyImage {...image} className="modal-image" objectFit="cover" />
      </ImageWrapper>
    </Modal>
  )
}

export default Popup
